module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_344764.849a5a75.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_344764.pdf
// module id = 324
// module chunks = 0